var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76428 17.6054C1.33678 17.6054 0.962709 17.4451 0.642078 17.1245C0.321448 16.8038 0.161133 16.4298 0.161133 16.0023V2.10828C0.161133 1.68077 0.321448 1.3067 0.642078 0.986072C0.962709 0.665442 1.33678 0.505127 1.76428 0.505127H15.6583C16.0858 0.505127 16.4598 0.665442 16.7805 0.986072C17.1011 1.3067 17.2614 1.68077 17.2614 2.10828V7.8529L21.5365 3.57783V14.5327L17.2614 10.2576V16.0023C17.2614 16.4298 17.1011 16.8038 16.7805 17.1245C16.4598 17.4451 16.0858 17.6054 15.6583 17.6054H1.76428Z",
    fill: "#4D6D9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.46d201be9e516568b702bec432553f0f.svg";
export { ForwardRef as ReactComponent };